import React from 'react';

import { Box, Button, CircularProgress, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { HISTORY_RETRY_LABEL } from '../../EntityAuditHistory.constants';
import { getStateMessageStyles } from '../../EntityAuditHistory.styles';

/**
 * The module's loading / empty / error + retry / unavailable presentation: a framed box for the
 * timeline states, or an inline line (`isFramed={false}`) inside a drill-in.
 */
const AuditStateMessage = ({
  message,
  dataTestId,
  isLoading = false,
  isFramed = true,
  onRetry = null,
  retryLabel = HISTORY_RETRY_LABEL,
  retryTestId = null,
}) => (
  <Box data-testid={dataTestId} sx={getStateMessageStyles({ isFramed, isLoading })}>
    {isLoading && <CircularProgress size={16} />}
    <Typography color="text.secondary" variant="regular14">
      {message}
    </Typography>
    {!!onRetry && (
      <Button data-testid={retryTestId} size="small" onClick={onRetry}>
        {retryLabel}
      </Button>
    )}
  </Box>
);

AuditStateMessage.propTypes = {
  message: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  isFramed: PropTypes.bool,
  retryLabel: PropTypes.string,
  retryTestId: PropTypes.string,
  onRetry: PropTypes.func,
};

export default AuditStateMessage;
